{
  "blocks": [
    {
      "id": "proc-urinalysis",
      "kind": "procedure",
      "tags": ["testing", "both-partners", "lab"],
      "title": "Urinalysis",
      "subtitle": "Urine test to screen for infections, kidney function, and other health markers",
      "body": {
        "procedureName": "Urinalysis",
        "category": "diagnostic",
        "description": "A urine test that checks for urinary tract infections, kidney issues, and other conditions that could impact fertility treatment. Often part of a standard pre-treatment workup.",
        "howItWorks": "You provide a mid-stream urine sample in a sterile cup at the clinic or lab. The sample is analyzed for color, clarity, pH, protein, glucose, bacteria, and white blood cells. A dipstick test gives quick results, while a microscopic examination and culture may take longer. The results help identify infections, kidney concerns, or metabolic conditions that should be addressed before fertility treatment.",
        "duration": "5 minutes to provide the sample",
        "anesthesia": "none",
        "whatToExpect": [
          "You'll be given a sterile collection cup and instructions for a clean-catch sample",
          "Dipstick results may be available within minutes",
          "Full culture results take 2–3 days if ordered",
          "If an infection is found, antibiotics are prescribed before starting treatment"
        ],
        "results": [
          {
            "label": "Quick screen",
            "detail": "Dipstick results may be available within minutes and can flag blood, protein, glucose, leukocytes, or nitrites."
          },
          {
            "label": "Culture",
            "detail": "If a urine culture is ordered, results usually take 2-3 days because bacteria need time to grow."
          },
          {
            "label": "Follow-up",
            "detail": "If infection is found, antibiotics are usually prescribed before fertility treatment continues."
          }
        ],
        "prepInstructions": [
          "Drink water beforehand so you can provide a sample easily",
          "Use the mid-stream clean-catch technique as instructed",
          "Avoid excessive fluid intake right before, as it can dilute the sample",
          "Inform your clinic of any antibiotics or medications you are taking"
        ],
        "risks": ["No physical risks: this is a non-invasive test"],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Analyse d'urine",
          "description": "Analyse urinaire recherchant infections urinaires, anomalies rénales et autres conditions susceptibles d'avoir un impact sur l'AMP. Souvent incluse dans le bilan pré-traitement.",
          "howItWorks": "Vous fournissez un échantillon d'urine de milieu de jet dans un récipient stérile, au centre ou au laboratoire. L'analyse porte sur la couleur, la limpidité, le pH, la présence de protéines, de glucose, de bactéries et de leucocytes. Une bandelette urinaire donne un résultat rapide, tandis qu'un examen microscopique et une mise en culture peuvent prendre plus de temps. Les résultats permettent d'identifier infections, atteinte rénale ou troubles métaboliques à prendre en charge avant le traitement.",
          "duration": "5 minutes pour fournir l'échantillon",
          "whatToExpect": [
            "On vous remet un récipient stérile et les consignes de recueil propre",
            "Les résultats de la bandelette peuvent être disponibles en quelques minutes",
            "Les résultats de culture prennent 2 à 3 jours si elle est demandée",
            "En cas d'infection, des antibiotiques sont prescrits avant de débuter le traitement"
          ],
          "results": [
            {
              "label": "Dépistage rapide",
              "detail": "Les résultats de bandelette peuvent être disponibles en quelques minutes et signaler sang, protéines, glucose, leucocytes ou nitrites."
            },
            {
              "label": "Culture",
              "detail": "Si une culture d'urine est demandée, les résultats prennent généralement 2 à 3 jours car les bactéries doivent pousser."
            },
            {
              "label": "Suivi",
              "detail": "Si une infection est trouvée, des antibiotiques sont habituellement prescrits avant la poursuite du traitement."
            }
          ],
          "prepInstructions": [
            "Buvez de l'eau au préalable pour pouvoir fournir un échantillon facilement",
            "Utilisez la technique de recueil de milieu de jet selon les indications",
            "Évitez les apports liquidiens excessifs juste avant, qui peuvent diluer l'échantillon",
            "Signalez à votre centre les antibiotiques ou traitements en cours"
          ],
          "risks": ["Aucun risque physique : examen non invasif"]
        }
      },
      "sources": [
        {
          "title": "Diagnosis and Treatment of Infertility in Men: AUA/ASRM Guideline",
          "authors": "Schlegel PN, Sigman M, Collura B, et al.",
          "journal": "Journal of Urology",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/diagnosis-and-treatment-of-infertility-in-men-auaasrm-guideline-part-i-2020/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
